import React from "react";
import gql from "graphql-tag";
import { useSubscription } from "@apollo/client";
import { noop } from "../../../utils/noop";

export const OnAccountUpdated = () => {
  useSubscription(onAccountUpdatedSubscription, {
    onSubscriptionData: ({ client: { cache }, subscriptionData }) => {
      try {
        const updatedAccount = subscriptionData?.data?.onAccountUpdated;
        if (updatedAccount.role === "CUSTOMER") {
          const prev = cache.readQuery({ query: getAccounts });

          const newData = {
            ...prev,
            accounts: prev.accounts.map((account) => {
              if (account.id === updatedAccount.id) {
                return {
                  email: updatedAccount.email
                    ? updatedAccount.email
                    : account.email,
                  id: updatedAccount.id ? updatedAccount.id : account.id,
                  name: updatedAccount.name,
                  parentId: updatedAccount.parentId
                    ? updatedAccount.parentId
                    : account.parentId,
                  role: updatedAccount.role
                    ? updatedAccount.role
                    : account.role,
                  status: updatedAccount.status
                    ? updatedAccount.status
                    : account.status,
                };
              } else {
                return account;
              }
            }),
          };

          cache.writeQuery({ query: getDistributors, data: newData });
        }

        if (updatedAccount.role !== "CUSTOMER") {
          const prev = cache.readQuery({ query: getDistributors });

          const newData = {
            ...prev,
            distributors: prev.distributors.map((dist) => {
              if (dist.id === updatedAccount.id) {
                return updatedAccount;
              } else {
                return dist;
              }
            }),
          };

          cache.writeQuery({ query: getDistributors, data: newData });
        }
      } catch (err) {
        noop();
      }
    },
  });

  return <div></div>;
};

const onAccountUpdatedSubscription = gql`
  subscription onAccountUpdated {
    onAccountUpdated {
      id
      clientId
      name
      email
      vat
      address
      postalCode
      country
      createdAt
      updatedAt
      role
      parentId
      suspendedAt
      status
    }
  }
`;

const getDistributors = gql`
  query {
    distributors {
      id
      name
      status
    }
  }
`;
const getAccounts = gql`
  query {
    accounts {
      id
      name
      status
    }
  }
`;
